import React from "react";
import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const stepMeta = [
  { n: "01", icon: "Users", img: IMAGES.family },
  { n: "02", icon: "Camera", img: IMAGES.ingredients },
  { n: "03", icon: "ChefHat", img: IMAGES.pasta },
  { n: "04", icon: "Vote", img: IMAGES.salad },
  { n: "05", icon: "CookingPot", img: IMAGES.swiss },
  { n: "06", icon: "Utensils", img: IMAGES.heroFamily }
];

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section id="so-gehts" className="scroll-mt-24 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
              {t.how.badge}
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
              {t.how.title}
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-petrol-soft">
              {t.how.subtitle}
            </p>
          </div>
        </Reveal>

        <div className="mt-12 space-y-6">
          {t.how.steps.map((s, i) => {
            const meta = stepMeta[i];
            const Icon = Icons[meta.icon] || Icons.Sparkles;
            const reverse = i % 2 === 1;
            return (
              <Reveal key={meta.n} delay={0.05}>
                <div
                  data-testid={`step-${i}`}
                  className={`grid items-center gap-6 overflow-hidden rounded-3xl bg-white p-6 shadow-[0_10px_40px_rgba(15,37,55,0.06)] sm:p-8 lg:grid-cols-2 ${
                    reverse ? "lg:[direction:rtl]" : ""
                  }`}
                >
                  <div className="[direction:ltr]">
                    <div className="flex items-center gap-4">
                      <span className="font-heading text-5xl font-extrabold text-terracotta/25">
                        {meta.n}
                      </span>
                      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-petrol text-cream">
                        <Icon className="h-6 w-6" strokeWidth={2} />
                      </span>
                    </div>
                    <h3 className="mt-4 font-heading text-2xl font-extrabold text-petrol">
                      {s.title}
                    </h3>
                    <p className="mt-2 max-w-md text-lg leading-relaxed text-petrol-soft">
                      {s.text}
                    </p>
                  </div>
                  <div className="[direction:ltr]">
                    <img
                      src={meta.img}
                      alt={s.title}
                      className="h-56 w-full rounded-2xl object-cover sm:h-64"
                      loading="lazy"
                    />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
